import React from "react";

function Particle() {
  return (
    <div id="tsparticles" className="professional-bg-grid" />
  );
}

export default Particle;
